import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  type: 'access-payroll',
  name: 'Access Payroll',
  category: 'access-integrations',
  description: 'Access Payroll integration',
  icon: 'Users',
  color: 'orange',
  version: '1.0.0',
  comingSoon: true,
  inputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Input',
      required: true,
    },
  ],
  outputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Output',
    },
  ],
};

export default definition;
